import React from "react";
import Card from "./Card";
import ContractAnalytics from "./ContractAnalytics";
import Notifications from "./Notifications";
import StatCard from "./StatCard";
import WelcomeBanner from "./WelcomeBanner";

const Main = () => {
  return (
    <div className="flex flex-col lg:flex-row bg-indigo-50 dark:bg-slate-900 min-h-screen">
      <section className="w-full lg:w-[70%] p-4 lg:p-6 overflow-y-auto no-scrollbar">
        <div className="flex items-center justify-between mb-6">
          <div className="text-indigo-950 w-full font-bold text-xl sm:text-2xl lg:text-3xl dark:text-transparent bg-clip-text dark:bg-gradient-to-l from-indigo-400 to-pink-400">
            <WelcomeBanner />
          </div>
        </div>

        <div className="mb-8">
          <StatCard />
        </div>

        <div className="mb-8">
          <Card />
        </div>

        <div className="mb-8">
          <ContractAnalytics />
        </div>
      </section>

      <section className="w-full lg:w-[30%] bg-indigo-100 dark:bg-slate-800 p-4 lg:p-6 overflow-y-auto no-scrollbar">
        <Notifications />
      </section>
    </div>
  );
};

export default Main;
